import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL_OSINT;

// const ELASTIC_API = process.env.VUE_APP_ELASTIC_API;

class TiktokService {
    // getTimelineTwint(data){
    //     return axios.post(API_URL+'twitter/get-timeline', data);
    // }
    getTimelineElastic(ip, username) {
        return axios.get(ip + 'osint_tiktok_timeline/_doc/' + username, { headers: { 'Content-Type': 'application/json' } });
    }
    createTimelineElastic(ip, username, data) {
        return axios.put(ip + 'osint_tiktok_timeline/_doc/' + username, data, { headers: { 'Content-Type': 'application/json' } });
    }

    getFollowingElastic(ip, username) {
        return axios.get(ip + 'osint_tiktok_following/_doc/' + username, { headers: { 'Content-Type': 'application/json' } });
    }
    createFollowingElastic(ip, username, data) {
        return axios.put(ip + 'osint_tiktok_following/_doc/' + username, data, { headers: { 'Content-Type': 'application/json' } });
    }
    getLastFollowing(data) {
        return axios.post(API_URL + 'tiktok/get-following', data);
    }

    getFollowersElastic(ip, username) {
        return axios.get(ip + 'osint_tiktok_followers/_doc/' + username, { headers: { 'Content-Type': 'application/json' } });
    }
    createFollowersElastic(ip, username, data) {
        return axios.put(ip + 'osint_tiktok_followers/_doc/' + username, data, { headers: { 'Content-Type': 'application/json' } });
    }
    getLastFollowers(data) {
        return axios.post(API_URL + 'tiktok/get-followers', data);
    }
}

export default new TiktokService();
